/**
 * Print Depot — instant variant price
 *
 * Horizon's variant picker refetches the section and morphs it, so the price
 * only updates once the network round trip finishes. This paints the new price
 * the moment an option is clicked; the morph that follows confirms it.
 *
 * Deliberately conservative. If the clicked option does not resolve to a price
 * we know, nothing is touched and the server result stands — a stale price for
 * a moment is far better than briefly showing the wrong one.
 *
 * Only products whose variants differ in price carry the data at all, so on
 * everything else this does nothing.
 */
(() => {
  const read = () => {
    const el = document.querySelector('[data-pd-variant-prices]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  };

  let prices = read();
  if (!prices) return;

  const paint = (variantId) => {
    const entry = prices[String(variantId)];
    if (!entry || !entry.price) return;

    // Every price readout in the product area: the main one and the sticky bar.
    // Compare-at markup is left alone — no product in this catalogue sets one,
    // and guessing at sale state is how a wrong price gets shown.
    const containers = document.querySelectorAll('[ref="priceContainer"], .sticky-add-to-cart__price');
    for (const container of containers) {
      for (const node of container.querySelectorAll('.price')) {
        if (node.textContent.trim() !== entry.price) node.textContent = entry.price;
      }
    }
  };

  document.addEventListener('change', (event) => {
    const el = event.target;
    if (!(el instanceof HTMLElement)) return;

    // The picker puts the resulting variant on each option control, which is
    // the same value it uses to build the URL it fetches.
    const id = el.dataset?.variantId || el.selectedOptions?.[0]?.dataset?.variantId;
    if (id) paint(id);
  });

  // The morph replaces the data along with the rest of the section.
  document.addEventListener('shopify:section:load', () => {
    prices = read() || prices;
  });
})();
